var map = {
	"./epilogue/Epilogue-Black.eot": 70,
	"./epilogue/Epilogue-Black.woff": 71,
	"./epilogue/Epilogue-Black.woff2": 72,
	"./epilogue/Epilogue-BlackItalic.eot": 73,
	"./epilogue/Epilogue-BlackItalic.woff": 74,
	"./epilogue/Epilogue-BlackItalic.woff2": 75,
	"./epilogue/Epilogue-Bold.eot": 76,
	"./epilogue/Epilogue-Bold.woff": 77,
	"./epilogue/Epilogue-Bold.woff2": 78,
	"./epilogue/Epilogue-BoldItalic.eot": 79,
	"./epilogue/Epilogue-BoldItalic.woff": 80,
	"./epilogue/Epilogue-BoldItalic.woff2": 81,
	"./epilogue/Epilogue-ExtraBold.eot": 82,
	"./epilogue/Epilogue-ExtraBold.woff": 83,
	"./epilogue/Epilogue-ExtraBold.woff2": 84,
	"./epilogue/Epilogue-ExtraBoldItalic.eot": 85,
	"./epilogue/Epilogue-ExtraBoldItalic.woff": 86,
	"./epilogue/Epilogue-ExtraBoldItalic.woff2": 87,
	"./epilogue/Epilogue-ExtraLight.eot": 88,
	"./epilogue/Epilogue-ExtraLight.woff": 89,
	"./epilogue/Epilogue-ExtraLight.woff2": 90,
	"./epilogue/Epilogue-ExtraLightItalic.eot": 91,
	"./epilogue/Epilogue-ExtraLightItalic.woff": 92,
	"./epilogue/Epilogue-ExtraLightItalic.woff2": 93,
	"./epilogue/Epilogue-Italic.eot": 94,
	"./epilogue/Epilogue-Italic.woff": 95,
	"./epilogue/Epilogue-Italic.woff2": 96,
	"./epilogue/Epilogue-Light.eot": 97,
	"./epilogue/Epilogue-Light.woff": 98,
	"./epilogue/Epilogue-Light.woff2": 99,
	"./epilogue/Epilogue-LightItalic.eot": 100,
	"./epilogue/Epilogue-LightItalic.woff": 101,
	"./epilogue/Epilogue-LightItalic.woff2": 102,
	"./epilogue/Epilogue-Medium.eot": 103,
	"./epilogue/Epilogue-Medium.woff": 104,
	"./epilogue/Epilogue-Medium.woff2": 105,
	"./epilogue/Epilogue-MediumItalic.eot": 106,
	"./epilogue/Epilogue-MediumItalic.woff": 107,
	"./epilogue/Epilogue-MediumItalic.woff2": 108,
	"./epilogue/Epilogue-Regular.eot": 109,
	"./epilogue/Epilogue-Regular.woff": 110,
	"./epilogue/Epilogue-Regular.woff2": 111,
	"./epilogue/Epilogue-SemiBold.eot": 112,
	"./epilogue/Epilogue-SemiBold.woff": 113,
	"./epilogue/Epilogue-SemiBold.woff2": 114,
	"./epilogue/Epilogue-SemiBoldItalic.eot": 115,
	"./epilogue/Epilogue-SemiBoldItalic.woff": 116,
	"./epilogue/Epilogue-SemiBoldItalic.woff2": 117,
	"./epilogue/Epilogue-Thin.eot": 118,
	"./epilogue/Epilogue-Thin.woff": 119,
	"./epilogue/Epilogue-Thin.woff2": 120,
	"./epilogue/Epilogue-ThinItalic.eot": 121,
	"./epilogue/Epilogue-ThinItalic.woff": 122,
	"./epilogue/Epilogue-ThinItalic.woff2": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;